
import { memo } from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/home/HeroSection';
import StatsSection from '@/components/home/StatsSection';
import FeaturedPropertiesSection from '@/components/home/FeaturedPropertiesSection';
import HowItWorksSection from '@/components/home/HowItWorksSection';
import ReviewsSection from '@/components/home/ReviewsSection';
import FaqSection from '@/components/home/FaqSection';
import PropertyOwnerSection from '@/components/home/PropertyOwnerSection';
import Footer from '@/components/home/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import SEOHead from '@/components/SEOHead';

const Home = memo(() => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Alojamientos en Manzanillo Colima | Hospedaje y Departamentos | Estancia Corta"
        description="Encuentra los mejores alojamientos en Manzanillo, Colima. Departamentos y hospedajes de calidad, bonitos y a buen precio. Reserva directa con super anfitriones. ¡Tu hogar en Manzanillo!"
        canonicalUrl="https://estanciacorta.com/"
      />
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <FeaturedPropertiesSection />
        <HowItWorksSection />
        <ReviewsSection />
        <FaqSection />
        <PropertyOwnerSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
});

Home.displayName = 'Home';

export default Home;
